import { ArLedgerReportType } from '@repo/types';
import { SelectOption } from '@repo/ui';
import { keyBy, mapValues } from 'lodash';

export const LEDGER_TYPE_OPTIONS: SelectOption[] = [
    { label: 'Client', value: ArLedgerReportType.CLIENT },
    { label: 'Matter', value: ArLedgerReportType.MATTER },
    { label: 'Responsible Attorney', value: ArLedgerReportType.RESPONSIBLE_ATTORNEY },
    { label: 'Originating Attorney', value: ArLedgerReportType.ORIGINATING_ATTORNEY },
];

export const LedgerTypeMapLabel = mapValues(keyBy(LEDGER_TYPE_OPTIONS, 'value'), (option: SelectOption) => option.label);
